import { Path } from "enums";
import CashInHistoryModule from "modules/cash/cashin-history/cashin-history.module";
import CashInModule from "modules/cash/cashin/cashin.module";
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

const CashPage = () => {
  return (
    <Switch>
      <Route exact path={Path.CashIn} component={CashInModule} />
      <Route exact path={Path.CashInHistory} component={CashInHistoryModule} />
      <Redirect to={Path.CashIn} />
    </Switch>
  );
};

export default CashPage;
